import { ValidatorFn } from '@angular/forms';

// TODO!: 本来は専用のライブラリを使用するべき
// https://github.com/zxcvbn-ts/zxcvbn

// (小文字(a-z) or 大文字(A-Z)) and 数字(0-9)
// 記号も可
// 8文字以上
const VALID_CHARS_REGEX = /^[ -~]+$/;
const NUMBERS_REGEX = /[0-9]+/;
const ALPHABETS_REGEX = /[A-Za-z]+/;

export const passwordValidator: ValidatorFn = (control) => {
  const value = control.value;
  if (typeof value !== 'string') {
    return { invalidType: 'password入力を行ってください。' };
  }
  if (value.length < 8) {
    return {
      tooShort:
        '半角の英字と数字を必ず含む8文字以上で入力してください。記号の使用も可能です。',
    };
  }
  for (const regex of [VALID_CHARS_REGEX, NUMBERS_REGEX, ALPHABETS_REGEX]) {
    if (!regex.test(value)) {
      return {
        invalidChars:
          '半角の英字と数字を必ず含む8文字以上で入力してください。記号の使用も可能です。',
      };
    }
  }

  return null;
};
